export default  [

  {
    key: "date",
    label: "Date",
    sortable: true
  },
  {
    key: "event_time",
    label: "Time"
  },

  {
    key: "plan",
    label: "Plan",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  {
    key: "owner",
    label: "Device",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },

  {
    key: "tag",
    label: "Container"
  },
]